/* eslint-disable */
import './AreaSelector.css';

import React, { useEffect, useState } from 'react';
import usePlansData from '../../hooks/usePlansData';
import B2BElementsExplorer from '../../../b2b-common/B2BElementsExplorer';
import PlanCard from '../PlanCard';
import { isEqual } from 'lodash';
import useGettingPlanData from '../../hooks/useGettingPlanData';
import { generateClassName } from '../../../b2b-common/helpers';
import B2BElementsExplorerInMemory from '../../../b2b-common/B2BElementsExplorerInMemory';
import AreaCard from './AreaCard';
import { getPlanAreaDTO } from './helper';

const AreaSelector = ({ selectedPlanAreaDTOs = [], onSelectedPlanAreaDTOsUpdate, multiselect = true, className = null, uneligibleAreaList = [] }) => {
    const plansPerPage = 4;
    const { organizationPlansData, currentPlansPage, setCurrentPlansPage, isSearching, pagesCount } =
        usePlansData(plansPerPage);
    const [planCurrentlySelected, setPlanCurrentlySelected] = useState(null);
    const [currentSelectedPlanAreaDTOs, setCurrentSelectedPlanAreaDTOs] = useState([]);

    useEffect(() => {
        // console.log('AreaSelector selectedPlanAreaDTOs:', selectedPlanAreaDTOs);
        if (!isEqual(selectedPlanAreaDTOs, currentSelectedPlanAreaDTOs))
            setCurrentSelectedPlanAreaDTOs(selectedPlanAreaDTOs);
    }, [selectedPlanAreaDTOs]);

    if (!organizationPlansData) return null;

    const handlePageChange = (event, value) => {
        if (value < 1 || value > pagesCount) return;
        if (value !== currentPlansPage) {
            setCurrentPlansPage(value);
            setPlanCurrentlySelected(null);
        }
    }

    const handlePlanSelected = (plan) => {
        // console.log('AreaSelector handlePlanSelected:', plan);
        if (isEqual(planCurrentlySelected, plan))
            setPlanCurrentlySelected(null);
        else
            setPlanCurrentlySelected(plan);
    }

    const handleSelectedPlanAreaDTOsUpdate = (selectedPlanAreaDTOs) => {
        // console.log('AreaSelector handleSelectedAreasUpdate:', selectedPlanAreaDTOs, areasFromPlan, planUUID);
        if (selectedPlanAreaDTOs) {
            onSelectedPlanAreaDTOsUpdate && onSelectedPlanAreaDTOsUpdate(selectedPlanAreaDTOs);
        }
    }

    return (
        <div className={generateClassName('area-selector-container','',className)}>
            <B2BElementsExplorer
                isSearching={isSearching}
                elementsData={organizationPlansData}
                pagesCount={pagesCount}
                currentPage={currentPlansPage}
                handlePageChange={handlePageChange}
                className={`area-selector-plans-explorer`}
                ElementComponent={PlanCard}
                otherComponentProps={{
                    datesRangeType: 'STANDARD',
                    showMoreButton: false,
                    selectedUUIDs: planCurrentlySelected ? [planCurrentlySelected?.planUUID] : [],
                }}
                elementComponentPropName='plan'
                elementComponentHandlers={{
                    onAccess: handlePlanSelected
                }}
                elementIDPropName='plan.planId'
            />
            {planCurrentlySelected && (
                <AreasInPlan planUUID={planCurrentlySelected.planUUID} selectedPlanAreaDTOs={currentSelectedPlanAreaDTOs}
                    onSelectedPlanAreaDTOsUpdate={handleSelectedPlanAreaDTOsUpdate}
                    multiselect={multiselect}
                    uneligibleAreaList={uneligibleAreaList}
                />
            )}
        </div>
    )

}

const AreasInPlan = ({ planUUID, selectedPlanAreaDTOs, onSelectedPlanAreaDTOsUpdate, multiselect = true, uneligibleAreaList = [] }) => {
    const { planData, isSearching } = useGettingPlanData(planUUID, true);
    const [currentAreas, setCurrentAreas] = useState([]);
    const [currentSelectedPlanAreaDTOs, setCurrentSelectedPlanAreaDTOs] = useState(selectedPlanAreaDTOs);
    const [selectedAreasInCurrentPlan, setSelectedAreasInCurrentPlan] = useState([]);
    const [currentAreasPage, setCurrentAreasPage] = useState(1);
    const [pagesCount, setPagesCount] = useState(1);

    const areasPerPage = 4;

    useEffect(() => {
        if (planData) {
            setCurrentAreas(planData.areaDTOs);
            setPagesCount(Math.ceil(planData.areaDTOs.length / areasPerPage));
        }
    }, [planData]);

    useEffect(() => {
        if (planData && selectedPlanAreaDTOs) {
            const areas = planData.areaDTOs.filter(area => selectedPlanAreaDTOs.some(planAreaDTO => planAreaDTO.planAreaId === area.areaId));
            setSelectedAreasInCurrentPlan(areas);
            setCurrentSelectedPlanAreaDTOs(selectedPlanAreaDTOs);
        }
    }, [planData, selectedPlanAreaDTOs]);

    const handlePageChange = (event, value) => {
        if (value < 1 || value > pagesCount) return;
        if (value !== currentAreasPage) {
            setCurrentAreasPage(value);
        }
    }

    const handleAreaSelected = (area) => {
        if (selectedPlanAreaDTOs.some(planAreaDTO => planAreaDTO.planAreaId === area.areaId)) { // area is already selected so I will remove it
            const planAreaDTOsToUpdate = currentSelectedPlanAreaDTOs.filter(planAreaDTO => planAreaDTO.planAreaId !== area.areaId);
            const areasInCurrentPlanToUpdate = selectedAreasInCurrentPlan.filter(a => a.areaId !== area.areaId);
            setCurrentSelectedPlanAreaDTOs(planAreaDTOsToUpdate);
            setSelectedAreasInCurrentPlan(areasInCurrentPlanToUpdate);
            onSelectedPlanAreaDTOsUpdate(planAreaDTOsToUpdate);
        } else { // area is not selected so I will add it
            if (multiselect) {
                const planAreaDTOsToUpdate = [...currentSelectedPlanAreaDTOs, getPlanAreaDTO(area)];
                const areasInCurrentPlanToUpdate = [...selectedAreasInCurrentPlan, area];
                setCurrentSelectedPlanAreaDTOs(planAreaDTOsToUpdate);
                setSelectedAreasInCurrentPlan(areasInCurrentPlanToUpdate);
                onSelectedPlanAreaDTOsUpdate(planAreaDTOsToUpdate);
            } else {
                const planAreaDTOsToUpdate = [getPlanAreaDTO(area)];
                const areasInCurrentPlanToUpdate = [area];
                setCurrentSelectedPlanAreaDTOs(planAreaDTOsToUpdate);
                setSelectedAreasInCurrentPlan(areasInCurrentPlanToUpdate);
                onSelectedPlanAreaDTOsUpdate(planAreaDTOsToUpdate);
            }
        }        
     }

    return (
        <B2BElementsExplorerInMemory
            numRows={areasPerPage}
            isSearching={isSearching}
            elementsData={{ content: currentAreas }}
            // className={`areas-in-plan-explorer area-card-theme-horizontal-01`}
            className={`areas-in-plan-explorer`}
            ElementComponent={AreaCard}
            otherComponentProps={{
                selectedPlanAreaDTOs: currentSelectedPlanAreaDTOs,
                uneligibleAreaList: uneligibleAreaList,
                // className: 'area-card-theme-horizontal-01'
            }}
            elementComponentHandlers={{
                onAccess: handleAreaSelected
            }}
            elementComponentPropName='area'
            elementIDPropName='area.areaId'
            currentPage={currentAreasPage}
            handlePageChange={handlePageChange}
            paginationStyle='edge-navigation'
        />
    )
}

export default AreaSelector;